import { render, staticRenderFns } from "./bsp-dicts-cascader.vue?vue&type=template&id=140d3bbe&scoped=true&"
import script from "./bsp-dicts-cascader.vue?vue&type=script&lang=js&"
export * from "./bsp-dicts-cascader.vue?vue&type=script&lang=js&"
import style0 from "./bsp-dicts-cascader.vue?vue&type=style&index=0&id=140d3bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140d3bbe",
  null
  
)

export default component.exports